<template>
  <div class="my-step">
    <dl class="my-step__msg">
      <dt>斗K体验</dt>
      <dd>本次活动期间，每天可体验<span class="red">1</span>个擂台</dd>
    </dl>
    <div class="my-step__btn"><a class="active" href="javascript:;" @click="goTrialDK">体验大厅</a></div>
  </div>
</template>

<script>
  import {
    mapActions
  } from 'vuex'
  export default {
    name: 'my-step-sign',
    methods: {
      ...mapActions(['goTrialDK'])
    }
  };

</script>
